import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EdlIconComponent } from './edl-icon.component';
import { EdlIconService } from './edl-icon.service';

@NgModule({
    declarations: [EdlIconComponent],
    imports: [CommonModule],
    providers: [EdlIconService],
    exports: [EdlIconComponent]
})
export class EdlIconModule {}
